// Feedback shares the paper-edit workspace, but it is a separate tab.
export function isEditorTabActive(tab,workspaceMode,feedbackOpen){
  if(tab==='feedback')return workspaceMode==='paper' && feedbackOpen;
  // Refine cuts is a finishing step inside Paper Edit, not a fourth top-level tab.
  if(tab==='paper')return workspaceMode==='refine' || (workspaceMode==='paper' && !feedbackOpen);
  if(tab==='transcript')return workspaceMode==='transcript';
  return false;
}
